import { staticText } from 'utils/staticText';

export const RewardCardGridTranslations = staticText({
  seeEligibleCards: {
    _: 'See Eligible Cards',
    zh: '選擇產品',
    'zh-hk': '選擇產品',
    'zh-tw': '選擇產品',
  },
  rewardDetails: {
    _: 'Reward Details',
    zh: '獎賞詳情',
    'zh-hk': '獎賞詳情',
    'zh-tw': '禮物詳情',
  },
});
